import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function Image ({
  src,
  defer = false,
  style = undefined,
  width = undefined,
  height = undefined,
  background = false,
  alt = '',
  className
}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (!defer) return;
    if (!window.IntersectionObserver) {
      return setIsVisible(true);
    }
    const intersectionObserver = new window.IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
      }
    });
    if (ref.current) {
      const elm = ref.current;
      intersectionObserver.observe(elm);
      return () => intersectionObserver.unobserve(elm);
    }
  }, [defer]);

  const currSrc = defer && !isVisible
    ? 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    : src;

  return (
    background
      ? (
        <div
          ref={ref}
          style={{
            ...style,
            width,
            height,
            backgroundImage: `url(${currSrc})`
          }}
          className={className}
        />
        )
      : (
        <img
          src={currSrc}
          ref={ref}
          style={{
            ...style
          }}
          width={width}
          height={height}
          alt={alt}
          className={className}
        />
        )
  );
}

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  defer: PropTypes.bool,
  style: PropTypes.object,
  background: PropTypes.bool
};

export default Image;
